module.exports = __webpack_public_path__ + "static/media/ZY.4c0c28a5.png";